// Fahrzeugfristen (TÜV, Inspektion, Eichung, Ölwechsel): Fälligkeit und
// Warn-Chips für Fahrzeugliste und Fahrzeugdetails. Schwellen wie beim P-Schein
// (utils/licenseExpiry.js): Chip ab 30 Tagen vor Fälligkeit, rot ab 7 Tagen.

import { DUE_MAINTENANCE_TYPES } from '../config/vehicleMaintenance';
import { toJsDate } from './licenseExpiry';

export const DEADLINE_WARN_DAYS = 30;

const DAY_MS = 86400000;

const startOfToday = () => {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), now.getDate());
};

/**
 * Fälligkeitsdatum je Wartungsart. `tuvDate` ist das ältere Feld „TÜV bis"
 * und dient als Rückfall, solange `maintenanceDue.tuv` fehlt.
 */
export const getVehicleDueDate = (vehicle, key) => {
  const value = vehicle?.maintenanceDue?.[key] ?? (key === 'tuv' ? vehicle?.tuvDate : null);
  return toJsDate(value);
};

/** Ganze Tage bis zur Fälligkeit (Kalendertage, heute = 0, negativ = überfällig). */
export const daysUntil = (date) => {
  if (!date) return null;
  const due = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  return Math.round((due.getTime() - startOfToday().getTime()) / DAY_MS);
};

export const getDeadlineStatus = (date, shortLabel) => {
  const days = daysUntil(date);
  if (days === null || days >= DEADLINE_WARN_DAYS) return null;
  if (days < 0) return { color: 'error', days, label: `${shortLabel} überfällig` };
  if (days === 0) return { color: 'error', days, label: `${shortLabel} heute fällig` };
  return { color: days <= 7 ? 'error' : 'warning', days, label: `${shortLabel}: ${days} T` };
};

/** Alle Fristen eines Fahrzeugs mit Datum und ggf. Warnstatus. */
export const getVehicleDeadlines = (vehicle) => (
  DUE_MAINTENANCE_TYPES.map((type) => {
    const date = getVehicleDueDate(vehicle, type.key);
    return { ...type, date, status: getDeadlineStatus(date, type.short) };
  })
);

/** Nur die Fristen, die einen Chip bekommen (fällig in < 30 Tagen oder überfällig). */
export const getVehicleDeadlineWarnings = (vehicle) => (
  getVehicleDeadlines(vehicle)
    .filter(deadline => deadline.status)
    .sort((a, b) => a.status.days - b.status.days)
);

export const addMonths = (date, months) => {
  const result = new Date(date.getTime());
  const day = result.getDate();
  result.setMonth(result.getMonth() + months);
  // 31.01. + 1 Monat → Monatsende statt 03.03.
  if (result.getDate() !== day) result.setDate(0);
  return result;
};
